import {
  AdproductsMoodysReportType,
  type CustomerAnalyticsMoodysAskingRentVacancyDto,
  type CustomerAnalyticsMoodysReportDto,
} from '@zg-rentals/ts-customer-analytics-client';
import { Image, Text, View } from '@react-pdf/renderer';
import { styles } from './pdfStyles';
import { MarketTrendsColumn, MarketTrendsPageWrapper, MarketTrendsTextHeader } from './MarketTrendsComponents';
import { getRowStyle } from './pdfImageUtils';

const currentYear = new Date().getFullYear();

export const VacancyTrendsPage = ({
  report,
  vacancyTrendsLineChartSrc,
  reportsInRange,
}: {
  report: CustomerAnalyticsMoodysReportDto;
  vacancyTrendsLineChartSrc: string;
  reportsInRange: Array<CustomerAnalyticsMoodysAskingRentVacancyDto>;
}) => {
  const reducer: Record<string, CustomerAnalyticsMoodysAskingRentVacancyDto> = {};
  const marketRentsByYear = report.askingRentVacancyTrendsReport.market.reduce((accumulator, currentValue) => {
    accumulator[currentValue.year] = currentValue;
    return accumulator;
  }, reducer);

  const hasSubmarketData = report.reportType === AdproductsMoodysReportType.SUBMARKET;
  const totalCols = hasSubmarketData ? 3 : 2;
  const colWidth = 100 / totalCols;

  return (
    <MarketTrendsPageWrapper quarter={report.dataAsOfQuarter} year={report.dataAsOfYear}>
      <View style={styles.containerBase}>
        <MarketTrendsTextHeader headerText="Vacancy Trends" paddingBottom={20} />
        <View style={{ flexDirection: 'row', width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          <View>
            <Image src={vacancyTrendsLineChartSrc} />
          </View>
        </View>
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <MarketTrendsColumn width={colWidth} />
            {hasSubmarketData && (
              <MarketTrendsColumn width={colWidth}>
                <Text>{report.submarketName}</Text>
              </MarketTrendsColumn>
            )}
            <MarketTrendsColumn width={colWidth}>
              <Text>{report.marketName}</Text>
            </MarketTrendsColumn>
          </View>
          <View style={styles.tableHeader}>
            <MarketTrendsColumn width={colWidth}>
              <Text>Year</Text>
            </MarketTrendsColumn>
            {hasSubmarketData && (
              <MarketTrendsColumn width={colWidth}>
                <Text>Vacancy Rate</Text>
                <Text style={styles.tableSubHeading}>%</Text>
              </MarketTrendsColumn>
            )}
            <MarketTrendsColumn width={colWidth}>
              <Text>Vacancy Rate</Text>
              <Text style={styles.tableSubHeading}>%</Text>
            </MarketTrendsColumn>
          </View>
          {reportsInRange
            .sort((a, b) => a.year - b.year)
            .filter((item) => item.year <= currentYear)
            .map((marketInventory, i) => (
              <View style={getRowStyle(i)} key={marketInventory.year}>
                <MarketTrendsColumn width={colWidth}>
                  <Text> {marketInventory.year}</Text>
                </MarketTrendsColumn>
                {hasSubmarketData && (
                  <MarketTrendsColumn width={colWidth}>
                    <Text> {(marketInventory.vacancyPercent * 100).toFixed(1)}%</Text>
                  </MarketTrendsColumn>
                )}
                <MarketTrendsColumn width={colWidth}>
                  <Text>{(marketRentsByYear[marketInventory.year].vacancyPercent * 100).toFixed(1)}%</Text>
                </MarketTrendsColumn>
              </View>
            ))}
        </View>
      </View>
    </MarketTrendsPageWrapper>
  );
};
